export const DOWNLOAD_CFDI = 'DOWNLOAD_CFDI'
